var _defs, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRrrainbow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "ffflurry-grad",
    gradientTransform: "rotate(270)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "hsl(0, 0%, 0%)",
    stopOpacity: 1,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "hsl(353, 98%, 41%)",
    stopOpacity: 1,
    offset: "45%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "hsl(37, 91%, 55%)",
    stopOpacity: 1,
    offset: "100%"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "hsl(0, 0%, 0%)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "url(#ffflurry-grad)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 151,
    height: 1,
    x: 47.5,
    y: 510.5,
    rx: 0.5,
    transform: "rotate(45, 123, 511)",
    opacity: 0.83
  }), /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 1,
    x: 249.5,
    y: 663.5,
    rx: 0.5,
    transform: "rotate(45, 288, 664)",
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 1,
    x: 182,
    y: 481.5,
    rx: 0.5,
    transform: "rotate(45, 226, 482)",
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    width: 202,
    height: 1,
    x: -63,
    y: 140.5,
    rx: 0.5,
    transform: "rotate(45, 38, 141)",
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 1,
    x: 637,
    y: 779.5,
    rx: 0.5,
    transform: "rotate(45, 656, 780)",
    opacity: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 1,
    x: 482.5,
    y: 454.5,
    rx: 0.5,
    transform: "rotate(45, 500, 455)",
    opacity: 0.39
  }), /*#__PURE__*/React.createElement("rect", {
    width: 297,
    height: 1,
    x: 314.5,
    y: 587.5,
    rx: 0.5,
    transform: "rotate(45, 463, 588)",
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 1,
    x: 737,
    y: 779.5,
    rx: 0.5,
    transform: "rotate(45, 759, 780)",
    opacity: 0.29
  }), /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 1,
    x: 427,
    y: 169.5,
    rx: 0.5,
    transform: "rotate(45, 499, 170)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 1,
    x: 99,
    y: 189.5,
    rx: 0.5,
    transform: "rotate(45, 138, 190)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 313,
    height: 1,
    x: -1.5,
    y: 634.5,
    rx: 0.5,
    transform: "rotate(45, 155, 635)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 121,
    height: 1,
    x: 481.5,
    y: 224.5,
    rx: 0.5,
    transform: "rotate(45, 542, 225)",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    width: 221,
    height: 1,
    x: 653.5,
    y: 523.5,
    rx: 0.5,
    transform: "rotate(45, 764, 524)",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("rect", {
    width: 133,
    height: 1,
    x: 653.5,
    y: 257.5,
    rx: 0.5,
    transform: "rotate(45, 720, 258)",
    opacity: 0.79
  }), /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 1,
    x: 315,
    y: 775.5,
    rx: 0.5,
    transform: "rotate(45, 345, 776)",
    opacity: 0.96
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 1,
    x: 5,
    y: 457.5,
    rx: 0.5,
    transform: "rotate(45, 18, 458)",
    opacity: 0.91
  }), /*#__PURE__*/React.createElement("rect", {
    width: 95,
    height: 1,
    x: 0.5,
    y: 223.5,
    rx: 0.5,
    transform: "rotate(45, 48, 224)",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("rect", {
    width: 231,
    height: 1,
    x: 150.5,
    y: 442.5,
    rx: 0.5,
    transform: "rotate(45, 266, 443)",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 1,
    x: 172,
    y: 617.5,
    rx: 0.5,
    transform: "rotate(45, 224, 618)",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 1,
    x: 301,
    y: 686.5,
    rx: 0.5,
    transform: "rotate(45, 352, 687)",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    width: 116,
    height: 1,
    x: 532,
    y: 80.5,
    rx: 0.5,
    transform: "rotate(45, 590, 81)",
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 1,
    x: 473,
    y: 71.5,
    rx: 0.5,
    transform: "rotate(45, 527, 72)",
    opacity: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    width: 322,
    height: 1,
    x: 422,
    y: 684.5,
    rx: 0.5,
    transform: "rotate(45, 583, 685)",
    opacity: 0.29
  }), /*#__PURE__*/React.createElement("rect", {
    width: 138,
    height: 1,
    x: 269,
    y: 618.5,
    rx: 0.5,
    transform: "rotate(45, 338, 619)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    width: 188,
    height: 1,
    x: 682,
    y: 355.5,
    rx: 0.5,
    transform: "rotate(45, 776, 356)",
    opacity: 0.73
  }), /*#__PURE__*/React.createElement("rect", {
    width: 162,
    height: 1,
    x: 302,
    y: 360.5,
    rx: 0.5,
    transform: "rotate(45, 383, 361)",
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("rect", {
    width: 186,
    height: 1,
    x: 533,
    y: 278.5,
    rx: 0.5,
    transform: "rotate(45, 626, 279)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    width: 157,
    height: 1,
    x: 461.5,
    y: 135.5,
    rx: 0.5,
    transform: "rotate(45, 540, 136)",
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 1,
    x: 229,
    y: 562.5,
    rx: 0.5,
    transform: "rotate(45, 266, 563)",
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 1,
    x: 448,
    y: 28.5,
    rx: 0.5,
    transform: "rotate(45, 492, 29)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    width: 139,
    height: 1,
    x: 258.5,
    y: 217.5,
    rx: 0.5,
    transform: "rotate(45, 328, 218)",
    opacity: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 1,
    x: 124.5,
    y: 433.5,
    rx: 0.5,
    transform: "rotate(45, 163, 434)",
    opacity: 0.29
  }), /*#__PURE__*/React.createElement("rect", {
    width: 213,
    height: 1,
    x: -47.5,
    y: 299.5,
    rx: 0.5,
    transform: "rotate(45, 59, 300)",
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    width: 139,
    height: 1,
    x: 285.5,
    y: 302.5,
    rx: 0.5,
    transform: "rotate(45, 355, 303)",
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("rect", {
    width: 266,
    height: 1,
    x: 632,
    y: 30.5,
    rx: 0.5,
    transform: "rotate(45, 765, 31)",
    opacity: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    width: 178,
    height: 1,
    x: 261,
    y: 468.5,
    rx: 0.5,
    transform: "rotate(45, 350, 469)",
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("rect", {
    width: 125,
    height: 1,
    x: 706.5,
    y: 636.5,
    rx: 0.5,
    transform: "rotate(45, 769, 637)",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    width: 174,
    height: 1,
    x: 362,
    y: 204.5,
    rx: 0.5,
    transform: "rotate(45, 449, 205)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 1,
    x: 90,
    y: 374.5,
    rx: 0.5,
    transform: "rotate(45, 128, 375)",
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 1,
    x: -10,
    y: 562.5,
    rx: 0.5,
    transform: "rotate(45, 118, 563)",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 1,
    x: 1,
    y: 534.5,
    rx: 0.5,
    transform: "rotate(45, 11, 535)",
    opacity: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    width: 168,
    height: 1,
    x: 490,
    y: 457.5,
    rx: 0.5,
    transform: "rotate(45, 574, 458)",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 171,
    height: 1,
    x: 644.5,
    y: 339.5,
    rx: 0.5,
    transform: "rotate(45, 730, 340)",
    opacity: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    width: 258,
    height: 1,
    x: 459,
    y: 529.5,
    rx: 0.5,
    transform: "rotate(45, 588, 530)",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    width: 107,
    height: 1,
    x: 584.5,
    y: 496.5,
    rx: 0.5,
    transform: "rotate(45, 638, 497)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 248,
    height: 1,
    x: 392,
    y: 389.5,
    rx: 0.5,
    transform: "rotate(45, 516, 390)",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 1,
    x: -17,
    y: 403.5,
    rx: 0.5,
    transform: "rotate(45, 34, 404)",
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("rect", {
    width: 136,
    height: 1,
    x: 336,
    y: 56.5,
    rx: 0.5,
    transform: "rotate(45, 404, 57)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 1,
    x: 335.5,
    y: 244.5,
    rx: 0.5,
    transform: "rotate(45, 379, 245)",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 136,
    height: 1,
    x: 712,
    y: 740.5,
    rx: 0.5,
    transform: "rotate(45, 780, 741)",
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 1,
    x: -6.5,
    y: 693.5,
    rx: 0.5,
    transform: "rotate(45, 23, 694)",
    opacity: 0.23
  }), /*#__PURE__*/React.createElement("rect", {
    width: 280,
    height: 1,
    x: 555,
    y: 438.5,
    rx: 0.5,
    transform: "rotate(45, 695, 439)",
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    width: 153,
    height: 1,
    x: 375.5,
    y: 745.5,
    rx: 0.5,
    transform: "rotate(45, 452, 746)",
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("rect", {
    width: 230,
    height: 1,
    x: 172,
    y: 277.5,
    rx: 0.5,
    transform: "rotate(45, 287, 278)",
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    width: 119,
    height: 1,
    x: 691.5,
    y: 472.5,
    rx: 0.5,
    transform: "rotate(45, 751, 473)",
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 1,
    x: 531.5,
    y: 728.5,
    rx: 0.5,
    transform: "rotate(45, 549, 729)",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 1,
    x: 557,
    y: 753.5,
    rx: 0.5,
    transform: "rotate(45, 604, 754)",
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("rect", {
    width: 125,
    height: 1,
    x: 383.5,
    y: 121.5,
    rx: 0.5,
    transform: "rotate(45, 446, 122)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    width: 183,
    height: 1,
    x: -18.5,
    y: 503.5,
    rx: 0.5,
    transform: "rotate(45, 73, 504)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    width: 118,
    height: 1,
    x: 427,
    y: 531.5,
    rx: 0.5,
    transform: "rotate(45, 486, 532)",
    opacity: 0.81
  }), /*#__PURE__*/React.createElement("rect", {
    width: 158,
    height: 1,
    x: 629,
    y: 50.5,
    rx: 0.5,
    transform: "rotate(45, 708, 51)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 270,
    height: 1,
    x: 467,
    y: 211.5,
    rx: 0.5,
    transform: "rotate(45, 602, 212)",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 1,
    x: 237,
    y: 73.5,
    rx: 0.5,
    transform: "rotate(45, 282, 74)",
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("rect", {
    width: 227,
    height: 1,
    x: 275.5,
    y: 177.5,
    rx: 0.5,
    transform: "rotate(45, 389, 178)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 123,
    height: 1,
    x: 474.5,
    y: 511.5,
    rx: 0.5,
    transform: "rotate(45, 536, 512)",
    opacity: 0.73
  }), /*#__PURE__*/React.createElement("rect", {
    width: 237,
    height: 1,
    x: 549.5,
    y: 321.5,
    rx: 0.5,
    transform: "rotate(45, 668, 322)",
    opacity: 0.82
  }), /*#__PURE__*/React.createElement("rect", {
    width: 177,
    height: 1,
    x: 128.5,
    y: 134.5,
    rx: 0.5,
    transform: "rotate(45, 217, 135)",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    width: 278,
    height: 1,
    x: -40,
    y: 99.5,
    rx: 0.5,
    transform: "rotate(45, 99, 100)",
    opacity: 0.73
  }), /*#__PURE__*/React.createElement("rect", {
    width: 187,
    height: 1,
    x: 347.5,
    y: 270.5,
    rx: 0.5,
    transform: "rotate(45, 441, 271)",
    opacity: 0.74
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 1,
    x: 519,
    y: 333.5,
    rx: 0.5,
    transform: "rotate(45, 559, 334)",
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("rect", {
    width: 254,
    height: 1,
    x: 271,
    y: 490.5,
    rx: 0.5,
    transform: "rotate(45, 398, 491)",
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 1,
    x: 510,
    y: 347.5,
    rx: 0.5,
    transform: "rotate(45, 610, 348)",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    width: 153,
    height: 1,
    x: 587.5,
    y: 725.5,
    rx: 0.5,
    transform: "rotate(45, 664, 726)",
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 1,
    x: 56,
    y: 488.5,
    rx: 0.5,
    transform: "rotate(45, 166, 489)",
    opacity: 0.81
  }), /*#__PURE__*/React.createElement("rect", {
    width: 167,
    height: 1,
    x: 0.5,
    y: 604.5,
    rx: 0.5,
    transform: "rotate(45, 84, 605)",
    opacity: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    width: 171,
    height: 1,
    x: 630.5,
    y: 748.5,
    rx: 0.5,
    transform: "rotate(45, 716, 749)",
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    width: 264,
    height: 1,
    x: 153,
    y: 356.5,
    rx: 0.5,
    transform: "rotate(45, 285, 357)",
    opacity: 0.82
  }), /*#__PURE__*/React.createElement("rect", {
    width: 165,
    height: 1,
    x: 145.5,
    y: 23.5,
    rx: 0.5,
    transform: "rotate(45, 228, 24)",
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("rect", {
    width: 233,
    height: 1,
    x: -42.5,
    y: 725.5,
    rx: 0.5,
    transform: "rotate(45, 74, 726)",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 146,
    height: 1,
    x: 222,
    y: 749.5,
    rx: 0.5,
    transform: "rotate(45, 295, 750)",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    width: 145,
    height: 1,
    x: 466.5,
    y: 577.5,
    rx: 0.5,
    transform: "rotate(45, 539, 578)",
    opacity: 0.79
  }), /*#__PURE__*/React.createElement("rect", {
    width: 248,
    height: 1,
    x: 604,
    y: 586.5,
    rx: 0.5,
    transform: "rotate(45, 728, 587)",
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("rect", {
    width: 179,
    height: 1,
    x: 197.5,
    y: 127.5,
    rx: 0.5,
    transform: "rotate(45, 287, 128)",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 143,
    height: 1,
    x: 695.5,
    y: 420.5,
    rx: 0.5,
    transform: "rotate(45, 767, 421)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 1,
    x: 199,
    y: 774.5,
    rx: 0.5,
    transform: "rotate(45, 222, 775)",
    opacity: 0.91
  }), /*#__PURE__*/React.createElement("rect", {
    width: 275,
    height: 1,
    x: 300.5,
    y: 392.5,
    rx: 0.5,
    transform: "rotate(45, 438, 393)",
    opacity: 0.91
  }), /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 1,
    x: 437,
    y: 739.5,
    rx: 0.5,
    transform: "rotate(45, 507, 740)",
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("rect", {
    width: 114,
    height: 1,
    x: 603,
    y: 672.5,
    rx: 0.5,
    transform: "rotate(45, 660, 673)",
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 1,
    x: 279,
    y: 29.5,
    rx: 0.5,
    transform: "rotate(45, 331, 30)",
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    width: 213,
    height: 1,
    x: 213.5,
    y: 535.5,
    rx: 0.5,
    transform: "rotate(45, 320, 536)",
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("rect", {
    width: 210,
    height: 1,
    x: 114,
    y: 315.5,
    rx: 0.5,
    transform: "rotate(45, 219, 316)",
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    width: 251,
    height: 1,
    x: 592.5,
    y: 668.5,
    rx: 0.5,
    transform: "rotate(45, 718, 669)",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 1,
    x: 157.5,
    y: 71.5,
    rx: 0.5,
    transform: "rotate(45, 190, 72)",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 111,
    height: 1,
    x: -33.5,
    y: 595.5,
    rx: 0.5,
    transform: "rotate(45, 22, 596)",
    opacity: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    width: 258,
    height: 1,
    x: 14,
    y: 771.5,
    rx: 0.5,
    transform: "rotate(45, 143, 772)",
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 1,
    x: 3,
    y: 348.5,
    rx: 0.5,
    transform: "rotate(45, 25, 349)",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 1,
    x: 390,
    y: 538.5,
    rx: 0.5,
    transform: "rotate(45, 421, 539)",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    width: 141,
    height: 1,
    x: 343.5,
    y: 633.5,
    rx: 0.5,
    transform: "rotate(45, 414, 634)",
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("rect", {
    width: 211,
    height: 1,
    x: 195.5,
    y: 178.5,
    rx: 0.5,
    transform: "rotate(45, 301, 179)",
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 1,
    x: 451,
    y: 321.5,
    rx: 0.5,
    transform: "rotate(45, 477, 322)",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("rect", {
    width: 174,
    height: 1,
    x: 556,
    y: 411.5,
    rx: 0.5,
    transform: "rotate(45, 643, 412)",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    width: 258,
    height: 1,
    x: 335,
    y: 678.5,
    rx: 0.5,
    transform: "rotate(45, 464, 679)",
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("rect", {
    width: 147,
    height: 1,
    x: 515.5,
    y: 402.5,
    rx: 0.5,
    transform: "rotate(45, 589, 403)",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 1,
    x: 29,
    y: 32.5,
    rx: 0.5,
    transform: "rotate(45, 125, 33)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 156,
    height: 1,
    x: 547,
    y: 631.5,
    rx: 0.5,
    transform: "rotate(45, 625, 632)",
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 1,
    x: -24,
    y: 777.5,
    rx: 0.5,
    transform: "rotate(45, 72, 778)",
    opacity: 0.13
  }), /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 1,
    x: 516,
    y: 280.5,
    rx: 0.5,
    transform: "rotate(45, 533, 281)",
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("rect", {
    width: 238,
    height: 1,
    x: 325,
    y: 467.5,
    rx: 0.5,
    transform: "rotate(45, 444, 468)",
    opacity: 0.83
  }), /*#__PURE__*/React.createElement("rect", {
    width: 124,
    height: 1,
    x: 83,
    y: 306.5,
    rx: 0.5,
    transform: "rotate(45, 145, 307)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 148,
    height: 1,
    x: 32,
    y: 453.5,
    rx: 0.5,
    transform: "rotate(45, 106, 454)",
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 1,
    x: 741.5,
    y: 108.5,
    rx: 0.5,
    transform: "rotate(45, 770, 109)",
    opacity: 0.27
  }), /*#__PURE__*/React.createElement("rect", {
    width: 241,
    height: 1,
    x: 572.5,
    y: 519.5,
    rx: 0.5,
    transform: "rotate(45, 693, 520)",
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    width: 169,
    height: 1,
    x: 693.5,
    y: 578.5,
    rx: 0.5,
    transform: "rotate(45, 778, 579)",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 1,
    x: 655,
    y: 273.5,
    rx: 0.5,
    transform: "rotate(45, 775, 274)",
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 1,
    x: 616.5,
    y: 91.5,
    rx: 0.5,
    transform: "rotate(45, 653, 92)",
    opacity: 0.72
  }), /*#__PURE__*/React.createElement("rect", {
    width: 95,
    height: 1,
    x: 565.5,
    y: 581.5,
    rx: 0.5,
    transform: "rotate(45, 613, 582)",
    opacity: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 1,
    x: 661,
    y: 594.5,
    rx: 0.5,
    transform: "rotate(45, 679, 595)",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 1,
    x: 39.5,
    y: 385.5,
    rx: 0.5,
    transform: "rotate(45, 83, 386)",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("rect", {
    width: 236,
    height: 1,
    x: -79,
    y: 43.5,
    rx: 0.5,
    transform: "rotate(45, 39, 44)",
    opacity: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    width: 179,
    height: 1,
    x: 240.5,
    y: 412.5,
    rx: 0.5,
    transform: "rotate(45, 330, 413)",
    opacity: 0.73
  }), /*#__PURE__*/React.createElement("rect", {
    width: 103,
    height: 1,
    x: 710.5,
    y: 183.5,
    rx: 0.5,
    transform: "rotate(45, 762, 184)",
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("rect", {
    width: 228,
    height: 1,
    x: 82,
    y: 381.5,
    rx: 0.5,
    transform: "rotate(45, 196, 382)",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 1,
    x: 12,
    y: 556.5,
    rx: 0.5,
    transform: "rotate(45, 53, 557)",
    opacity: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    width: 181,
    height: 1,
    x: 533.5,
    y: 24.5,
    rx: 0.5,
    transform: "rotate(45, 624, 25)",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("rect", {
    width: 170,
    height: 1,
    x: 141,
    y: 725.5,
    rx: 0.5,
    transform: "rotate(45, 226, 726)",
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 1,
    x: -14,
    y: 643.5,
    rx: 0.5,
    transform: "rotate(45, 31, 644)",
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    width: 312,
    height: 1,
    x: 376,
    y: 638.5,
    rx: 0.5,
    transform: "rotate(45, 532, 639)",
    opacity: 0.13
  }), /*#__PURE__*/React.createElement("rect", {
    width: 109,
    height: 1,
    x: 554.5,
    y: 151.5,
    rx: 0.5,
    transform: "rotate(45, 609, 152)",
    opacity: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 1,
    x: 113.5,
    y: 138.5,
    rx: 0.5,
    transform: "rotate(45, 142, 139)",
    opacity: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 1,
    x: 516.5,
    y: 782.5,
    rx: 0.5,
    transform: "rotate(45, 548, 783)",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("rect", {
    width: 252,
    height: 1,
    x: 63,
    y: 550.5,
    rx: 0.5,
    transform: "rotate(45, 189, 551)",
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 1,
    x: 443,
    y: 785.5,
    rx: 0.5,
    transform: "rotate(45, 469, 786)",
    opacity: 0.23
  }), /*#__PURE__*/React.createElement("rect", {
    width: 98,
    height: 1,
    x: 643,
    y: 376.5,
    rx: 0.5,
    transform: "rotate(45, 692, 377)",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("rect", {
    width: 228,
    height: 1,
    x: -25,
    y: 665.5,
    rx: 0.5,
    transform: "rotate(45, 89, 666)",
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 1,
    x: 196.5,
    y: 678.5,
    rx: 0.5,
    transform: "rotate(45, 230, 679)",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 1,
    x: 19.5,
    y: 448.5,
    rx: 0.5,
    transform: "rotate(45, 60, 449)",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    width: 170,
    height: 1,
    x: 171,
    y: 187.5,
    rx: 0.5,
    transform: "rotate(45, 256, 188)",
    opacity: 0.79
  }), /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 1,
    x: 729.5,
    y: 696.5,
    rx: 0.5,
    transform: "rotate(45, 768, 697)",
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 1,
    x: 588,
    y: 187.5,
    rx: 0.5,
    transform: "rotate(45, 688, 188)",
    opacity: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    width: 147,
    height: 1,
    x: 76.5,
    y: 709.5,
    rx: 0.5,
    transform: "rotate(45, 150, 710)",
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("rect", {
    width: 217,
    height: 1,
    x: -87.5,
    y: 760.5,
    rx: 0.5,
    transform: "rotate(45, 21, 761)",
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 1,
    x: 97,
    y: 247.5,
    rx: 0.5,
    transform: "rotate(45, 134, 248)",
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("rect", {
    width: 227,
    height: 1,
    x: 586.5,
    y: 129.5,
    rx: 0.5,
    transform: "rotate(45, 700, 130)",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 1,
    x: 217,
    y: 238.5,
    rx: 0.5,
    transform: "rotate(45, 244, 239)",
    opacity: 0.83
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 1,
    x: 183.5,
    y: 222.5,
    rx: 0.5,
    transform: "rotate(45, 198, 223)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    width: 243,
    height: 1,
    x: 273.5,
    y: 743.5,
    rx: 0.5,
    transform: "rotate(45, 395, 744)",
    opacity: 0.71
  }), /*#__PURE__*/React.createElement("rect", {
    width: 198,
    height: 1,
    x: 559,
    y: 229.5,
    rx: 0.5,
    transform: "rotate(45, 658, 230)",
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 1,
    x: 286,
    y: 128.5,
    rx: 0.5,
    transform: "rotate(45, 351, 129)",
    opacity: 0.73
  }), /*#__PURE__*/React.createElement("rect", {
    width: 191,
    height: 1,
    x: 282.5,
    y: 569.5,
    rx: 0.5,
    transform: "rotate(45, 378, 570)",
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 1,
    x: -0.5,
    y: 507.5,
    rx: 0.5,
    transform: "rotate(45, 33, 508)",
    opacity: 0.58
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRrrainbow);
export default __webpack_public_path__ + "static/media/rrrainbow.ff7060085a0e35db11de192d6e6a8704.svg";
export { ForwardRef as ReactComponent };